<!-- A fejlécet (ügyfél, év, fülek) a Tárgyi eszköz modul kerete adja (eszkoz-layout). -->
<div class="ures eszk-nincs-ugyfel" *ngIf="!aktiv.ugyfelId">
  <ion-icon name="business-outline"></ion-icon>Válassz ügyfelet a fejlécben – a Könyvelés ügyfelei közül.
</div>

<ng-container *ngIf="aktiv.ugyfelId && adat">
  <p class="n-megj mg-sugo">
    <ion-icon name="information-circle-outline"></ion-icon>
    A bérbe adott eszközök megtérülése. A bérleti díjat és a kiadást a könyvelésben a bizonylat <b>„Tárgyi eszközhöz”</b> gombjával rendeled
    az eszközhöz (a számla egyes sorai is választhatók), vagy itt kézzel veszed fel – a kiadás ráaktiválás nélkül. A jövőbeli dátumú sor
    <b>tervezett</b>: a tényleges számokba nem, a becslésbe beleszámít. Összegek: {{ adat.afa_alany ? 'nettó' : 'bruttó (alanyi mentes ügyfél)' }}.
  </p>

  <!-- Összesítő -->
  <div class="mg-csempek" *ngIf="adat.eszkozok.length">
    <div class="n-panel mg-csempe"><span>Bekerülési érték</span><b>{{ adat.osszesen.bekerules | number:'1.0-0' }}</b></div>
    <div class="n-panel mg-csempe"><span>Bérleti díj</span><b class="zold">{{ adat.osszesen.bevetel | number:'1.0-0' }}</b></div>
    <div class="n-panel mg-csempe"><span>Kiadás</span><b class="piros">{{ adat.osszesen.kiadas | number:'1.0-0' }}</b></div>
    <div class="n-panel mg-csempe"><span>Nettó hozam</span><b>{{ adat.osszesen.hozam | number:'1.0-0' }}</b></div>
    <div class="n-panel mg-csempe" title="Nettó hozam − bekerülési érték: pozitív, ha az eszköz már többet hozott, mint amennyibe került">
      <span>Haszon (pénzügyi)</span><b [class.zold]="adat.osszesen.haszon_penzugyi >= 0" [class.piros]="adat.osszesen.haszon_penzugyi < 0">{{ adat.osszesen.haszon_penzugyi | number:'1.0-0' }}</b></div>
    <div class="n-panel mg-csempe" title="Bevétel − kiadás − az eddig elszámolt értékcsökkenés">
      <span>Eredmény (számviteli)</span><b [class.zold]="adat.osszesen.haszon_szamviteli >= 0" [class.piros]="adat.osszesen.haszon_szamviteli < 0">{{ adat.osszesen.haszon_szamviteli | number:'1.0-0' }}</b></div>
  </div>

  <div class="ures" *ngIf="!adat.eszkozok.length && !betolt">
    <ion-icon name="cash-outline"></ion-icon>Még nincs bérbe adott eszköz. Könyveld a bérleti díj számláját, és a bizonylaton a „Tárgyi eszközhöz” gombbal
    rendeld az eszközhöz – vagy válassz lent egy eszközt, és vedd fel kézzel.
  </div>

  <div class="tabla-wrap" *ngIf="adat.eszkozok.length">
    <table class="n-racs mg-tabla">
      <thead><tr>
        <th>Eszköz</th><th class="num">Bekerülési érték</th><th class="num">Bérleti díj</th><th class="num">Kiadás</th><th class="num">Nettó hozam</th>
        <th>Megtérülés</th><th class="num" title="Az utolsó 12 hónap (vagy a kezdet óta) havi átlagos nettó hozama">Havi átlag</th>
        <th class="num" title="Az évesített havi átlag a bekerülési érték arányában">Éves hozam</th><th class="num">Eredmény (számv.)</th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let e of adat.eszkozok" (click)="reszletNyit(e.id)" style="cursor:pointer" title="Részletek, sorok felvétele">
          <td><b>{{ e.megnevezes }}</b><span class="halvany" *ngIf="e.leltari_szam"> · {{ e.leltari_szam }}</span>
            <div class="halvany mg-kicsi">{{ e.csoport_nev }} · {{ e.kezdet }} óta<ng-container *ngIf="e.kivezetes_datum"> · kivezetve {{ e.kivezetes_datum }}</ng-container></div></td>
          <td class="num">{{ e.bekerules | number:'1.0-0' }}</td>
          <td class="num zold">{{ e.bevetel | number:'1.0-0' }}</td>
          <td class="num piros">{{ e.kiadas | number:'1.0-0' }}</td>
          <td class="num"><b>{{ e.hozam | number:'1.0-0' }}</b></td>
          <td class="mg-megterules">
            <div class="mg-csik"><div [style.width.%]="arany(e)" [class.kesz]="e.megterult"></div></div>
            <div class="mg-kicsi">
              <ng-container *ngIf="e.megterult"><b class="zold">Megtérült</b> {{ e.megterult_datum }} ({{ honapSzoveg(e.megterulesi_ido_honap) }} alatt)</ng-container>
              <ng-container *ngIf="!e.megterult">{{ e.megterules_szazalek ?? 0 }}%
                <ng-container *ngIf="e.becsles?.datum"> · becslés: <b>{{ e.becsles.datum }}</b><span *ngIf="e.becsles.honap"> (még {{ honapSzoveg(e.becsles.honap) }})</span></ng-container>
                <span class="piros" *ngIf="e.becsles && !e.becsles.datum"> · {{ e.becsles.megjegyzes }}</span>
              </ng-container>
              <span class="halvany" *ngIf="e.tervezett_bevetel || e.tervezett_kiadas"> · tervezett sorokkal</span>
            </div>
          </td>
          <td class="num">{{ e.havi_atlag | number:'1.0-0' }}</td>
          <td class="num">{{ e.eves_hozam_szazalek != null ? e.eves_hozam_szazalek + '%' : '' }}</td>
          <td class="num" [class.zold]="e.haszon_szamviteli >= 0" [class.piros]="e.haszon_szamviteli < 0">{{ e.haszon_szamviteli | number:'1.0-0' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="mg-uj" *ngIf="adat.nem_berbe.length">
    <span class="halvany">Másik eszköz a kimutatásba:</span>
    <select [(ngModel)]="ujEszkoz"><option [ngValue]="null">– válassz eszközt –</option>
      <option *ngFor="let e of adat.nem_berbe" [ngValue]="e.id">{{ e.leltari_szam ? e.leltari_szam + ' – ' : '' }}{{ e.megnevezes }}</option></select>
    <button type="button" class="ov-gomb" [disabled]="!ujEszkoz" (click)="ujEszkozNyit()"><ion-icon name="add-outline"></ion-icon>Sor felvétele</button>
  </div>
</ng-container>

<!-- ═══ RÉSZLET ═══ -->
<ion-modal [isOpen]="!!reszlet" (didDismiss)="reszlet = null; uj = null" class="ber-urlap-modal ber-szeles-modal" cssClass="ber-urlap-modal ber-szeles-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>{{ reszlet?.megnevezes }} – megtérülés</ion-title>
      <ion-buttons slot="end"><ion-button (click)="reszlet = null">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="mg-reszlet" *ngIf="reszlet as e">
        <div class="mg-csempek">
          <div class="n-panel mg-csempe"><span>Bekerülési érték</span><b>{{ e.bekerules | number:'1.0-0' }}</b></div>
          <div class="n-panel mg-csempe"><span>Nettó hozam</span><b>{{ e.hozam | number:'1.0-0' }}</b></div>
          <div class="n-panel mg-csempe"><span>Még vissza kell jönnie</span><b>{{ (e.bekerules - e.hozam > 0 ? e.bekerules - e.hozam : 0) | number:'1.0-0' }}</b></div>
          <div class="n-panel mg-csempe"><span>{{ e.megterult ? 'Megtérült' : 'Becsült megtérülés' }}</span>
            <b>{{ e.megterult ? e.megterult_datum : (e.becsles?.datum || '–') }}</b></div>
          <div class="n-panel mg-csempe"><span>Havi átlag ({{ e.atlag_honap }} hó)</span><b>{{ e.havi_atlag | number:'1.0-0' }}</b></div>
          <div class="n-panel mg-csempe" title="Bevétel − kiadás − elszámolt écs ({{ e.halmozott_ecs | number:'1.0-0' }})"><span>Eredmény (számviteli)</span>
            <b [class.zold]="e.haszon_szamviteli >= 0" [class.piros]="e.haszon_szamviteli < 0">{{ e.haszon_szamviteli | number:'1.0-0' }}</b></div>
        </div>
        <p class="piros mg-kicsi" *ngIf="e.becsles && !e.becsles.datum">{{ e.becsles.megjegyzes }}</p>

        <!-- Automatikus hozzárendelés: a partner könyvelt számlái magától ide kerülnek -->
        <div class="n-panel mg-szabaly">
          <div class="mg-ujsor-cim">Automatikus hozzárendelés
            <span class="halvany">· a szabálynak megfelelő könyvelt számlák magától ide kerülnek (a korábbiak is)</span></div>
          <div class="mg-szab-sor" *ngFor="let sz of szabalyok">
            <span class="cimke" [class.zold]="sz.tipus === 'bevetel'" [class.piros-c]="sz.tipus === 'kiadas'">{{ sz.tipus === 'bevetel' ? 'bérleti díj' : 'kiadás' }}</span>
            <span>{{ sz.tipus === 'bevetel' ? 'Vevőszámla' : 'Szállítói számla' }}<ng-container *ngIf="sz.partner_nev">, partner: <b>{{ sz.partner_nev }}</b></ng-container>
              <ng-container *ngIf="sz.kulcsszo">, sor: „<b>{{ sz.kulcsszo }}</b>”</ng-container><ng-container *ngIf="sz.tol">, {{ sz.tol }}-tól</ng-container></span>
            <span class="halvany">· {{ sz.kotve }} sor</span>
            <button type="button" class="kv-mini" title="Szabály törlése" (click)="szabalyTorol(sz)"><ion-icon name="trash-outline"></ion-icon></button>
          </div>
          <div class="mg-szab-urlap" *ngIf="ujSzabaly as sz">
            <label class="kv-mezo"><span>Partner neve (tartalmazza)</span><input type="text" [(ngModel)]="sz.partner_nev" placeholder="pl. Gazsi Gyöngyi"></label>
            <label class="kv-mezo"><span>Számlasor kulcsszó (nem kötelező)</span><input type="text" [(ngModel)]="sz.kulcsszo" placeholder="pl. bérleti díj – csak az ilyen sorok"></label>
            <label class="kv-mezo"><span>Ettől a naptól</span><input type="date" [(ngModel)]="sz.tol"></label>
            <div class="nk-lab">
              <button type="button" class="ov-gomb" (click)="ujSzabaly = null">Mégse</button>
              <button type="button" class="ov-gomb fo" (click)="szabalyMent()"><ion-icon name="flash-outline"></ion-icon>Szabály mentése</button>
            </div>
          </div>
          <div class="mg-gombok" *ngIf="!ujSzabaly">
            <button type="button" class="ov-gomb" (click)="szabalyUj('bevetel')"><ion-icon name="flash-outline"></ion-icon>Bérleti díj automatikusan</button>
            <button type="button" class="ov-gomb" (click)="szabalyUj('kiadas')"><ion-icon name="flash-outline"></ion-icon>Kiadás automatikusan</button>
          </div>
        </div>

        <div class="mg-gombok">
          <button type="button" class="ov-gomb" (click)="ujSor('bevetel')"><ion-icon name="add-circle-outline"></ion-icon>Bérleti díj kézzel</button>
          <button type="button" class="ov-gomb" (click)="ujSor('kiadas')"><ion-icon name="remove-circle-outline"></ion-icon>Kiadás (ráaktiválás nélkül)</button>
        </div>

        <div class="n-panel mg-ujsor" *ngIf="uj">
          <div class="mg-ujsor-cim">{{ uj.tipus === 'bevetel' ? 'Bérleti díj' : 'Kiadás' }} felvétele
            <span class="halvany" *ngIf="uj.datum > maiNap">· tervezett (jövőbeli dátum) – csak a becslésbe számít</span></div>
          <div class="mg-ujsor-mezok">
            <label class="kv-mezo"><span>Dátum</span><input type="date" [(ngModel)]="uj.datum"></label>
            <label class="kv-mezo mg-szeles"><span>Megnevezés</span><input type="text" [(ngModel)]="uj.megnevezes" [placeholder]="uj.tipus === 'kiadas' ? 'pl. javítás, biztosítás, szerviz' : 'pl. bérleti díj 2026. október'"></label>
            <label class="kv-mezo"><span>Nettó</span><input type="number" [(ngModel)]="uj.netto"></label>
            <label class="kv-mezo"><span>ÁFA</span><input type="number" [(ngModel)]="uj.afa"></label>
            <label class="kv-mezo"><span>Bruttó</span><input type="number" [(ngModel)]="uj.brutto" [placeholder]="(+uj.netto || 0) + (+uj.afa || 0) + ''"></label>
          </div>
          <div class="nk-lab">
            <button type="button" class="ov-gomb" (click)="uj = null">Mégse</button>
            <button type="button" class="ov-gomb fo" (click)="ujMent()"><ion-icon name="save-outline"></ion-icon>Mentés</button>
          </div>
        </div>

        <div class="tabla-wrap" style="margin:0">
          <table class="n-racs">
            <thead><tr><th>Dátum</th><th>Típus</th><th>Megnevezés</th><th>Forrás</th><th class="num">Összeg</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let s of e.sorok" [class.mg-terv]="tervezett(s)">
                <td>{{ s.datum }}</td>
                <td><span class="cimke" [class.zold]="s.tipus === 'bevetel'" [class.piros-c]="s.tipus === 'kiadas'">{{ s.tipus === 'bevetel' ? 'bérleti díj' : 'kiadás' }}</span>
                  <span class="cimke" *ngIf="tervezett(s)">tervezett</span></td>
                <td>{{ s.megnevezes }}<span class="halvany" *ngIf="s.megjegyzes"> · {{ s.megjegyzes }}</span></td>
                <td class="halvany"><span class="cimke" *ngIf="s.szabaly_id" title="Automatikus hozzárendelés (szabály)">auto</span>{{ s.forras === 'kezi' ? 'kézi' : (s.szamlaszam || 'könyvelt bizonylat') }}<ng-container *ngIf="s.osa_sor"> · {{ s.osa_sor }}. sor</ng-container></td>
                <td class="num" [class.piros]="s.tipus === 'kiadas'">{{ (s.tipus === 'kiadas' ? -osszeg(s) : osszeg(s)) | number:'1.0-0' }}</td>
                <td><button type="button" class="kv-mini" title="Törlés" (click)="sorTorol(s)"><ion-icon name="trash-outline"></ion-icon></button></td>
              </tr>
              <tr *ngIf="!e.sorok?.length"><td colspan="6" class="halvany">Még nincs sor.</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>
